import { useSessionConfiguration } from 'src/app/shared/hooks/sessionConfiguration';

export function useMaintenanceBanner(): string {
	const {
		featureConfigs: { maintenanceBanner },
	} = useSessionConfiguration();

	return maintenanceBanner || '';
}
